export const IntercomSetup = {
  appId: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
}

export const isIntercomEnabled =
  process.env.NEXT_PUBLIC_ENABLE_INTERCOM === 'true'
